module.exports = __webpack_public_path__ + "img/DSC_1082.4042a914.jpg";